import { render, staticRenderFns } from "./DexSafeModal.vue?vue&type=template&id=0fd9445d&scoped=true"
import script from "./DexSafeModal.vue?vue&type=script&lang=ts"
export * from "./DexSafeModal.vue?vue&type=script&lang=ts"
import style0 from "./DexSafeModal.vue?vue&type=style&index=0&id=0fd9445d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd9445d",
  null
  
)

export default component.exports